import { useTranslations } from '@vocab/react';
import translations from './.vocab';
import {
  Box,
  ButtonIcon,
  Card,
  Column,
  Columns,
  Drawer,
  IconEdit,
  Stack,
  Text,
  useToast,
} from 'braid-design-system';
import { useEffect, useState } from 'react';

import FormContainer from './Form/FormContainer';
import { useAnalytics } from 'src/contexts/AnalyticsContext';

const ChangePassword = () => {
  const { t } = useTranslations(translations);
  const { trackAccountLink } = useAnalytics();

  const [openingEventTriggered, setOpeningEventTriggered] = useState(false);
  useEffect(() => {
    if (openingEventTriggered) {
      trackAccountLink({
        eventName: 'settings_section_displayed',
        currentPageSection: 'change password',
      });
    }
  }, [openingEventTriggered, trackAccountLink]);

  const [drawerOpened, setDrawerOpened] = useState(false);
  const [success, setSuccess] = useState(false);
  const toggle = () => {
    const wasClosed = drawerOpened === false;
    if (wasClosed) {
      setOpeningEventTriggered(true);
      setSuccess(false);
    }
    setDrawerOpened((currentState) => !currentState);
  };

  const showToast = useToast();
  useEffect(() => {
    if (success === true) {
      showToast({
        key: 'changeEmailSuccessToast',
        tone: 'positive',
        message: t('All Done! Your password has been updated.'),
      });
    }
  }, [showToast, success, t]);

  return (
    <Box data-testid="change-password-card">
      <Card rounded>
        <Columns space="small">
          <Column>
            <Stack space="medium">
              <Text weight="strong">{t('Password')}</Text>
            </Stack>
          </Column>
          <Column width="content">
            <ButtonIcon
              id="changePasswordButton"
              variant="transparent"
              icon={<IconEdit />}
              label={t('Change password')}
              onClick={toggle}
            />
          </Column>
        </Columns>
      </Card>

      <Drawer
        id="changePasswordDrawer"
        title={t('Change password')}
        open={drawerOpened === true}
        onClose={toggle}
        width="small"
      >
        <FormContainer toggle={toggle} setSuccess={setSuccess} />
      </Drawer>
    </Box>
  );
};

export default ChangePassword;
